import { checkWithMediumJson } from './checkWithMediumJson';

/**
 * ตรวจสอบค่า RBC (Red Blood Cell) โดยใช้ค่าปกติจาก medium.json
 * @param {string|number} value - ค่า RBC
 * @param {number} age - อายุ (ปี)
 * @param {string|number} gender - เพศ (male/female หรือ 1/0)
 * @returns {Promise<object>} - {title, color, caption, suggest}
 */
export default async (value, age, gender) => {
  return await checkWithMediumJson(value, 'RBC', gender, age, 'จำนวนเม็ดเลือดแดง');
};
